export default function(code, credentials = {}, html = true) {
  let injectedCode = code
  if (credentials.userId) {
    if (credentials.applicationId) {
      injectedCode = injectedCode.replace(
        /(["'])(YourApplicationID)(["'])/g,
        html
          ? `$1<span data-hj-suppress>${credentials.applicationId}</span>$3`
          : `$1${credentials.applicationId}$3`
      )
    }
    if (credentials.writeApiKey) {
      injectedCode = injectedCode.replace(
        /(["'])(MyApiKey|YourAdminAPIKey|YourAPIKey|API-Key)(["'])/g,
        html
          ? `$1
             <button id="show-password" class="py-4 px-8 rounded text-white border-solid border-white border">
               <svg class="w-12 h-12 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 22">
                 <path d="M17 9h-1V6c0-3.3-2.7-6-6-6S4 2.7 4 6v3H3c-1.7 0-3 1.3-3 3v7c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3v-7C20 10.3 18.7 9 17 9zM6 6c0-2.2 1.8-4 4-4s4 1.8 4 4v3H6V6z"/>
               </svg>
             </button>
             <span id="encrypted-password">••••••••••••••••••••••••••••••••</span>
             <span id="api-key" class="hidden" data-hj-suppress>
               ${credentials.writeApiKey}
             </span>
             $3`
              .replace(/^\s+|\s+$/gm, '')
              .split('\n')
              .join('')
          : `$1${credentials.writeApiKey}$3`
      )
    }
    if (credentials.searchApiKey) {
      injectedCode = injectedCode.replace(
        /(["'])(YourSearchOnlyAPIKey)(["'])/g,
        html
          ? `$1<span data-hj-suppress>${credentials.searchApiKey}</span>$3`
          : `$1${credentials.searchApiKey}$3`
      )
    }
  } else {
    injectedCode = injectedCode.replace(
      /(["'])(YourApplicationID|MyApiKey|YourAdminAPIKey|YourAPIKey|YourSearchOnlyAPIKey|API-Key)(["'])/g,
      html
        ? '<span class="snippet-wrapper-info group bg-dolphin cursor-pointer">$1$2$3</span>'
        : '$1$2$3'
    )
  }
  return injectedCode
}
